import {useMix} from '@hconnect/tuc-processes/fields/mix/useMix'

/**
 * Known step identifiers for material variations step.
 * Supports both string values and enum values from different step type systems.
 */
const MATERIAL_VARIATIONS_STEP_IDENTIFIERS = [
  'MIX_CHARACTERISTICS',
  'mix_characteristics',
  'materialVariations'
] as const

/**
 * Hook to check material variations state.
 * Determines whether the reset button should be shown based on current step and configured values.
 *
 * @param currentStep - The current step identifier (can be enum value or string)
 * @returns Object containing:
 *   - shouldShowResetButton: Whether to show the reset button (true when on material variations step with configured values)
 */
export const useMaterialVariationsState = (currentStep: string | unknown) => {
  const {selectedMaterialVariations} = useMix()

  // Check if currently on the material variations step
  const isOnMaterialVariationsStep = MATERIAL_VARIATIONS_STEP_IDENTIFIERS.includes(
    currentStep as any
  )

  // Show reset button if on material variations step AND values are configured (slump or setControl)
  const shouldShowResetButton =
    isOnMaterialVariationsStep &&
    selectedMaterialVariations &&
    (!!selectedMaterialVariations.slump?.value || !!selectedMaterialVariations.setControl?.value)

  return {
    shouldShowResetButton
  }
}
